import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { isOidcAuthenticated } from '../services/apiClient';

const NotFound: React.FC = () => {
  // Auth state comes from the ZewstID OIDC session — the legacy authStore's
  // `isAuthenticated` is always false under OIDC, which sent signed-in
  // instructors to /login from a 404.
  const isAuthenticated = isOidcAuthenticated();
  const location = useLocation();
  const home = isAuthenticated ? '/' : '/login';

  return (
    <div
      role="alert"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        padding: 24,
        gap: 16,
        fontFamily: 'system-ui, sans-serif',
        background: '#0f172a',
        color: '#e2e8f0',
        textAlign: 'center',
      }}
    >
      <div style={{ fontSize: 96, fontWeight: 700, lineHeight: 1, color: '#3b82f6' }}>404</div>
      <h1 style={{ margin: 0, fontSize: 28 }}>Page not found</h1>
      <p style={{ margin: 0, maxWidth: 480, color: '#94a3b8' }}>
        We couldn't find <code style={{ color: '#e2e8f0' }}>{location.pathname}</code>. It may have
        been moved, or the link is wrong.
      </p>
      <Link
        to={home}
        style={{
          marginTop: 12,
          padding: '10px 20px',
          background: '#3b82f6',
          color: '#fff',
          textDecoration: 'none',
          borderRadius: 6,
          fontWeight: 500,
        }}
      >
        {isAuthenticated ? 'Back to dashboard' : 'Go to sign in'}
      </Link>
    </div>
  );
};

export default NotFound;
